import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { cloneDeep } from 'lodash';
import { TypeMessage } from './state/layout.actions';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  constructor(private toastr: ToastrService) {}

  showMessage(typeMessage: TypeMessage, message: string, timeOut?: number) {
    const auxMessage = cloneDeep(message);
    switch (typeMessage) {
      case TypeMessage.info: {
        this.toastr.info(auxMessage, '', { timeOut });
        break;
      }
      case TypeMessage.error: {
        this.toastr.error(auxMessage, '', { timeOut });
        break;
      }
      case TypeMessage.success: {
        this.toastr.success(auxMessage, '', { timeOut });
        break;
      }
      case TypeMessage.permission: {
        this.toastr.error(auxMessage, '', { disableTimeOut: true });
        break;
      }
      default: {
        this.toastr.info(auxMessage, '', { timeOut });
      }
    }
  }

  clear() {
    this.toastr.clear();
  }
}
